var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTelegram(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.1693 3.08795C15.1693 3.08795 16.5454 2.55139 16.4307 3.85447C16.3925 4.39104 16.0485 6.26901 15.7809 8.30029L14.8636 14.3175C14.8636 14.3175 14.7871 15.199 14.0991 15.3523C13.411 15.5056 12.379 14.8157 12.1879 14.6624C12.035 14.5474 9.32116 12.8228 8.36555 11.9796C8.09797 11.7496 7.79219 11.2897 8.40376 10.7531L12.4173 6.92057C12.8759 6.46065 13.3346 5.38752 11.4234 6.69061L6.07214 10.3316C6.07214 10.3316 5.46057 10.7148 4.31388 10.3699L1.82934 9.60338C1.82934 9.60338 0.91197 9.0285 2.47914 8.45358C6.3015 6.65225 11.003 4.8126 15.1693 3.08795Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.3fe87ced7032ad8d871e77159098c316.svg";
export { ForwardRef as ReactComponent };